import React from 'react';
import { Global, css } from '@emotion/core';

/** Mulish */
import Mulish from '../../assets/fonts/Mulish/Mulish-VariableFont.ttf';
/** Lexend */
import Lexend from '../../assets/fonts/Lexend/static/Lexend-Regular.ttf';
import LexendMedium from '../../assets/fonts/Lexend/static/Lexend-Medium.ttf';
import LexendBold from '../../assets/fonts/Lexend/Lexend-VariableFont_wght.ttf';
/** Work Sans */
import WorkSansRegular from '../../assets/fonts/WorkSans/WorkSans-Regular.ttf';
import WorkSansLight from '../../assets/fonts/WorkSans/WorkSans-Light.ttf';
import WorkSansLightItalic from '../../assets/fonts/WorkSans/WorkSans-LightItalic.ttf';
import WorkSansItalic from '../../assets/fonts/WorkSans/WorkSans-Italic.ttf';
import WorkSansMedium from '../../assets/fonts/WorkSans/WorkSans-Medium.ttf';
import WorkSansSemiBold from '../../assets/fonts/WorkSans/WorkSans-SemiBold.ttf';
import WorkSansSemiBoldItalic from '../../assets/fonts/WorkSans/WorkSans-SemiBoldItalic.ttf';
import WorkSansBold from '../../assets/fonts/WorkSans/WorkSans-Bold.ttf';
import WorkSansBoldItalic from '../../assets/fonts/WorkSans/WorkSans-BoldItalic.ttf';
import WorkSansExtraBold from '../../assets/fonts/WorkSans/WorkSans-ExtraBold.ttf';
/** Merriweather */
import MerriweatherLight from '../../assets/fonts/Merriweather/Merriweather-Light.ttf';
import MerriweatherRegular from '../../assets/fonts/Merriweather/Merriweather-Regular.ttf';
import MerriweatherBold from '../../assets/fonts/Merriweather/Merriweather-Bold.ttf';
import MerriweatherBlack from '../../assets/fonts/Merriweather/Merriweather-Black.ttf';
/** Merriweather Sans */
import MerriweatherSansMedium from '../../assets/fonts/MerriweatherSans/static/MerriweatherSans-Medium.ttf';
import MerriweatherSansBold from '../../assets/fonts/MerriweatherSans/static/MerriweatherSans-Bold.ttf';
import { COLORS } from '../../constants';

export const StyledGlobal = (): JSX.Element => {
  return (
    <Global
      styles={css`
        * {
          box-sizing: border-box;
        }
        html,
        body {
          padding: 0;
          margin: 0;
          min-height: 100%;
          font-family: 'Work Sans', sans-serif;
          font-weight: 600;
          scroll-behavior: smooth;
          box-sizing: border-box;
        }
        body {
          background: white;
        }

        img {
          max-width: 100%;
          width: auto;
        }

        .cc-color-override--1608664607.cc-window {
          color: ${COLORS.seaBlue}!important;
          background-color: ${COLORS.whiteSmoke}!important;
          border: 2px solid ${COLORS.seaBlue}!important;
        }
        .cc-color-override--1608664607 .cc-btn {
          background-color: ${COLORS.seaBlue}!important;
        }
        .cc-color-override--1608664607 .cc-link,
        .cc-color-override--1608664607 .cc-link:active,
        .cc-color-override--1608664607 .cc-link:visited {
          color: ${COLORS.seaBlue}!important;
        }

        @font-face {
          font-family: 'Mulish';
          font-weight: 600;
          src: url(${Mulish as string}) format('truetype');
        }

        @font-face {
          font-family: 'Mulish';
          font-weight: 700;
          src: url(${Mulish as string}) format('truetype');
        }

        @font-face {
          font-family: 'Mulish';
          font-weight: 800;
          src: url(${Mulish as string}) format('truetype');
        }

        @font-face {
          font-family: 'Lexend';
          font-weight: 400;
          src: url(${Lexend as string});
        }

        @font-face {
          font-family: 'Lexend';
          font-weight: 500;
          src: url(${LexendMedium as string});
        }

        @font-face {
          font-family: 'Lexend';
          font-weight: 600;
          src: url(${LexendBold as string}) format('truetype');
        }

        @font-face {
          font-family: 'Work Sans';
          font-weight: 300;
          src: url(${WorkSansLight as string});
        }

        @font-face {
          font-family: 'Work Sans';
          font-weight: 300;
          font-style: italic;
          src: url(${WorkSansLightItalic as string});
        }

        @font-face {
          font-family: 'Work Sans';
          font-weight: 400;
          src: url(${WorkSansRegular as string});
        }

        @font-face {
          font-family: 'Work Sans';
          font-style: italic;
          src: url(${WorkSansItalic as string});
        }

        @font-face {
          font-family: 'Work Sans';
          font-weight: 500;
          src: url(${WorkSansMedium as string});
        }

        @font-face {
          font-family: 'Work Sans';
          font-weight: 600;
          src: url(${WorkSansSemiBold as string});
        }

        @font-face {
          font-family: 'Work Sans';
          font-weight: 600;
          font-style: italic;
          src: url(${WorkSansSemiBoldItalic as string});
        }

        @font-face {
          font-family: 'Work Sans';
          font-weight: 700;
          src: url(${WorkSansBold as string});
        }

        @font-face {
          font-family: 'Work Sans';
          font-weight: 700;
          font-style: italic;
          src: url(${WorkSansBoldItalic as string});
        }

        @font-face {
          font-family: 'Work Sans';
          font-weight: 800;
          src: url(${WorkSansExtraBold as string});
        }

        @font-face {
          font-family: 'Merriweather';
          src: url(${MerriweatherLight as string});
        }

        @font-face {
          font-family: 'Merriweather';
          font-weight: 600;
          src: url(${MerriweatherRegular as string});
        }

        @font-face {
          font-family: 'Merriweather';
          font-weight: 700;
          src: url(${MerriweatherBold as string});
        }

        @font-face {
          font-family: 'Merriweather';
          font-weight: 800;
          src: url(${MerriweatherBlack as string}) format('truetype');
        }

        @font-face {
          font-family: 'Merriweather-Sans';
          src: url(${MerriweatherSansMedium as string});
        }

        @font-face {
          font-family: 'Merriweather-Sans';
          font-weight: 600;
          src: url(${MerriweatherSansMedium as string});
        }

        @font-face {
          font-family: 'Merriweather-Sans';
          font-weight: bold;
          src: url(${MerriweatherSansMedium as string});
        }

        @font-face {
          font-family: 'Merriweather-Sans';
          font-weight: 800;
          src: url(${MerriweatherSansBold as string});
        }
      `}
    />
  );
};
